import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { Eye } from "lucide-react";
import axios from "axios";
import $ from 'jquery';
import 'datatables.net-dt/css/dataTables.dataTables.min.css';
import DataTable from 'datatables.net-dt';
import './style.css';
import config from "../../../config";

const Footer = () => (
  <footer className="w-full max-w-5xl mt-8 text-center text-gray-400 text-sm">
    <p>&copy; {new Date().getFullYear()} Your Company. All rights reserved.</p>
  </footer>
);

const ManageOrders = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchOrders = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await axios.get(`${config.baseURL}/userdata`);
        const data = response.data;

        if (Array.isArray(data)) {
          setOrders(data);
          setTimeout(() => {
            $('#ordersTable').DataTable({
              responsive: true,
              scrollX: true,
              autoWidth: false,
              fixedColumns: true,
              pageLength: 10,
              lengthMenu: [5, 10, 25, 50, 100],
              dom: '<"top"lf>rt<"bottom"ip>',
              language: {
                search: "_INPUT_",
                searchPlaceholder: "Search orders...",
              },
              initComplete: function(){
                this.api().columns.adjust();
              }
            });
          }, 0);
        } else {
          console.error("Unexpected response format:", data);
          setOrders([]);
          setError("Received unexpected data format from the server.");
        }
      } catch (err) {
        console.error("Error fetching orders:", err);
        setOrders([]);
        setError("Failed to fetch orders. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchOrders();

    return () => {
      const table = $('#ordersTable').DataTable();
      if (table) {
        table.destroy();
      }
    };
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-900 text-white flex items-center justify-center">
        <p className="text-xl">Loading orders...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-gray-900 text-white flex items-center justify-center">
        <p className="text-xl text-red-500">{error}</p>
      </div>
    );
  }

  const filteredOrders = orders.filter(order => order.status === 'completed');

  return (
    <div className="min-h-screen text-black dark:text-white flex flex-col items-center">
      <div className="w-full bg-white dark:bg-gray-900 rounded-lg shadow-xl overflow-hidden mb-8">
        <div className="px-6 py-5 border-b dark:border-gray-700 flex justify-between items-center">
          <div>
            <p className="text-2xl font-bold text-black dark:text-white">Manage Orders</p>
            <p className="mt-1 text-gray-400">
              View and manage all received orders.
            </p>
          </div>
        </div>
        <div className="p-6">
          <div className="relative overflow-x-auto shadow-md rounded-lg">
          <table id="ordersTable" className="min-w-full divide-y divide-gray-700 text-sm text-gray-700 dark:text-white">
            <thead className="bg-gray-100 dark:bg-gray-800 ">
              <tr>
                <th scope="col" className="px-6 py-3 text-left dark:tedt-white text-xs font-medium uppercase tracking-wider">
                  ID
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider">
                  Full Name
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider">
                  Email
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider">
                  Phone
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider">
                  Country
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider">
                  Address
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider">
                  Orderd At
                </th>
                <th scope="col" className="px-6 py-3 text-center text-xs font-medium uppercase tracking-wider">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white dark:bg-gray-800 divide-y divide-gray-700">
              {filteredOrders.length > 0 ? (
                filteredOrders.map((user, index) => (
                  <tr key={user.id} className="transition-colors duration-150 hover:bg-gray-50 dark:hover:bg-gray-700 border-b dark:border-gray-700">
                    <td className="px-6 py-4 whitespace-nowrap text-left text-sm font-medium text-gray-600 dark:text-gray-300">
                      {index + 1+'.'}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-left text-sm text-gray-600 dark:text-gray-300">
                      {user.first_name+" "+user.last_name || "N/A"}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-left text-sm text-gray-600 dark:text-gray-300">
                      {user.email || "N/A"}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-left text-sm text-gray-600 dark:text-gray-300">
                      {user.phone || "N/A"}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-left text-sm text-gray-600 dark:text-gray-300">
                      {user.country || "N/A"}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-left text-sm text-gray-600 dark:text-gray-300">
                      {user.address || "N/A"}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-left text-sm text-gray-600 dark:text-gray-300">
                      {user.created_at || "N/A"}
                    </td>
                    <td className="px-4 py-3 text-center">
                      <div className="flex justify-center items-center gap-x-3">
                        <NavLink
                          to={`/admin/orderditems/${user.id}`}
                          className="bg-green-100 text-green-700 p-2 rounded-full hover:bg-green-200 dark:hover:bg-green-900 transition"
                          title="View Order"
                        >
                          <Eye size={20} />
                        </NavLink>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="8" className="px-6 py-4 whitespace-nowrap text-center text-lg text-gray-400">
                    No orders found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ManageOrders;